import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import type { LedgerDrawerProps } from '../types';

export interface LedgerDrawerState {
  /** When non-null, the drawer renders with these props. */
  props: LedgerDrawerProps | null;
}

const initialState: LedgerDrawerState = {
  props: null,
};

export const ledgerDrawerSlice = createSlice({
  name: 'patientLedger/drawer',
  initialState,
  reducers: {
    /**
     * Open the drawer (or update its props if already open). Calling this
     * twice doesn't stack — the second call replaces the first set of props.
     * That gives us the "destination surface" semantics for free: any
     * trigger lands you in the right state.
     */
    openLedgerDrawer(state, action: PayloadAction<LedgerDrawerProps>) {
      state.props = action.payload;
    },
    closeLedgerDrawer(state) {
      state.props = null;
    },
  },
});

export const { openLedgerDrawer, closeLedgerDrawer } = ledgerDrawerSlice.actions;
export default ledgerDrawerSlice.reducer;
